var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"canvas-border"},[_c('h2',[_vm._v("Floor Area")]),_vm._v(" "),_c('v-stage',{ref:"stage",staticClass:"img-content",attrs:{"config":_vm.stageSize}},[_c('v-layer',{ref:"layer"},[_c('v-image',{staticClass:"image-canvas-popUp",attrs:{"config":{
				image: _vm.image,
				width: _vm.imageWidth,
				height: _vm.imageHeight
			}}}),_vm._v(" "),_c('v-image',{staticClass:"image-canvas-popUp",attrs:{"config":{
				image: _vm.upLayer,
				width: _vm.imageWidth,
				height: _vm.imageHeight
				}}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03090da1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/take-off-tool/tabs-components/pops/floorReferenceSvg.vue
// module id = null
// module chunks = 